import { getCurrentInstance, ComponentInternalInstance, isRef } from "vue";
import i18n from "@/assets/lang/index";

import router from "../router";
import { useRoute } from "vue-router";
import store from "../store";
import api from "../axios/api";

export default function getBase() {
  const { t, te, locale } = i18n.global;

  const $api = api;
  const $router = router;
  const $store = store;

  const initParam = function (
    param: any,
    pagination?: any,
    judgeEmpty?: boolean
  ) {
    if (undefined == judgeEmpty || null == judgeEmpty) {
      judgeEmpty = true;
    }
    let result;
    if (isRef(param)) {
      result = param.value;
    } else {
      result = param;
    }
    if (undefined != pagination && null != pagination) {
      result.page = pagination.value.page - 1;
      result.size = pagination.value.pageSize;
    }
    if (judgeEmpty) {
      for (const key in result) {
        if (
          undefined === result[key] ||
          null === result[key] ||
          "" === result[key]
        ) {
          delete result[key];
        }
      }
    }
    return result;
  };

  const changeParam = function (param: any, data: any) {
    for (const key in param) {
      param[key] = data[key];
    }
    return param;
  };

  const getEnumLabel = function (
    enumData: any,
    enumField: string,
    field?: string
  ) {
    field = !field ? "field" : field;
    let label = enumField
      ? te("enum." + enumField + "." + enumData[field])
        ? t("enum." + enumField + "." + enumData[field])
        : enumData.desc
      : enumData.desc;
    return label;
  };

  const getEnumOptions = function (data: any, setting?: any) {
    const enums = [];
    let field = !setting ? "field" : !setting.field ? "field" : setting.field;
    let enumField = !setting
      ? null
      : !setting.enumField
      ? null
      : setting.enumField;
    for (let i = 0; i < data.length; i++) {
      let label = getEnumLabel(data[i], enumField, field);
      enums.push({
        label: label,
        value: data[i][field],
        disabled: !setting
          ? false
          : !setting.disabledFields
          ? false
          : setting.disabledFields.indexOf(data[i].field) != -1,
      });
    }
    return enums;
  };

  const reInitAuth = function () {
    $api.common.clearAuth().then((res: any) => {
      $store.commit("setAuth", res);
    });
  };

  const getUrl = function (
    sourceName: string,
    targetName: string,
    params?: any
  ) {
    let url = window.location.href;
    url = url.replace(getPathByName(sourceName), getPathByName(targetName));
    if (params) {
      for (const key in params) {
        url = url.replace(":" + key, params[key]);
      }
    }
    return url;
  };

  const getPathByName = function (name: string) {
    let routes = <any>$router.getRoutes();
    for (const key in routes) {
      const route = routes[key];
      if (route.name == name) {
        return route.path;
      }
    }
    return "";
  };

  const hasPerms = function (perms: any, logical?: any) {
    if (!$store?.state?.auth?.perms) {
      return false;
    }
    if (perms) {
      if (!logical) {
        logical = "OR";
      }
      logical = logical.toUpperCase();
      let result = false;
      if (logical === "OR") {
        result = false;
      } else if (logical === "AND") {
        result = true;
      }
      let list = [];
      if (Array.isArray(perms)) {
        list = perms;
      } else {
        list = [perms];
      }
      for (let i = 0; i < list.length; i++) {
        let perm = list[i];
        if (logical === "OR") {
          if ($store.state.auth.perms.indexOf(perm) > -1) {
            return true;
          }
        } else if (logical === "AND") {
          if ($store.state.auth.perms.indexOf(perm) == -1) {
            return false;
          }
        }
      }
      return result;
    }
    return true;
  };
  const hasRoles = function (roles: any, logical?: any) {
    if (!$store.state.auth.roles) {
      return false;
    }
    if (roles) {
      if (!logical) {
        logical = "OR";
      }
      logical = logical.toUpperCase();
      let result = false;
      if (logical === "OR") {
        result = false;
      } else if (logical === "AND") {
        result = true;
      }
      let list = [];
      if (Array.isArray(roles)) {
        list = roles;
      } else {
        list = [roles];
      }
      for (let i = 0; i < list.length; i++) {
        let role = list[i];
        if (logical === "OR") {
          if ($store.state.auth.roles.indexOf(role) > -1) {
            return true;
          }
        } else if (logical === "AND") {
          if ($store.state.auth.roles.indexOf(role) == -1) {
            return false;
          }
        }
      }
      return result;
    }
    return true;
  };

  return {
    $api,
    $router,
    $store,
    t,
    te,
    locale,
    initParam,
    changeParam,
    getEnumLabel,
    getEnumOptions,
    useRoute,
    reInitAuth,
    getUrl,
    hasPerms,
    hasRoles,
  };
}
